<template>
  <div class="long-text" v-if="onlyValue">
    <div class="show-txt" :class="{'show-txt-rest':readonly}" v-if="!isFoucs" @click="getBlur">
      <div class="only-value" v-if="currentValue && currentValue.length > 0">
        <toolTip class="only-value" :style="{'width':'100%'}" :title="currentValue || '-'">{{currentValue || '-'}}</toolTip>
      </div>
      <span v-else class="add-txt" :class="{ readonly }">{{readonly ? '暂无' : '添加'}}</span>
    </div>
    <el-input v-bind="$props" v-else ref="inputLongText" @blur="setBlurFoucs()" v-model="currentValue" @change="changeVal" clearable :maxlength="config.max_length * 1 / 4" :placeholder="config.component_desc_in_template"></el-input>
  </div>
  <div v-else-if="currentValue || !readonly">
    <div class="long-text">
      <div class="show-txt" :class="{'show-txt-rest':readonly}" v-if="!isFoucs" @click="getBlur">
        <div class="only-value" v-if="currentValue && currentValue.length > 0">
          <toolTip class="only-value" :style="{'width':'100%'}" :title="currentValue || '-'">{{currentValue || '-'}}</toolTip>
        </div>
        <span v-else class="add-txt">添加</span>
      </div>
      <el-input v-bind="$props" v-else ref="inputLongText" @blur="setBlurFoucs()" v-model="currentValue" @change="changeVal" clearable :maxlength="config.max_length * 1 / 4" :placeholder="config.component_desc_in_template"></el-input>
    </div>
  </div>
</template>

<script>
export default {
  props: ['config', 'value', 'defaultValue', 'onlyValue', 'item', 'getketText', 'readonly'],
  data() {
    return {
      date: '',
      isFoucs: false,
      dataset: ''
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    getBlur() {
      if (this.readonly) return
      this.isFoucs = true
      this.$nextTick(() => {
        this.$refs.inputLongText.focus()
      })
    },
    init() {
      if (this.defaultValue && this.defaultValue.length > 0) {
        let val = this.getDefaultValue(this.defaultValue)
        this.$emit('input', val)
        this.dataset = val
      }
    },
    getDefaultValue(val) {
      if (val && val.length > 0) {
        return val[0].component_value
      }
    },
    getMessage(res) {
      return `<span class="message-mixin-tip">${res.field_name}</span><span class="message-mixin-task">${res.old_data}</span><span class="message-mixin-tip">修改为</span><span class="message-mixin-task">${res.new_data}</span>;`
    },
    changeVal(val, lr) {
      this.$emit('change', val, lr)
    },
    setBlurFoucs() {
      this.isFoucs = false
    }
  }
}
</script>

<style lang="scss">
.long-text {
}
</style>
